<template>
    <div class="report-info-container">
        <section class="report-info">
            <section class="image-container">
                <img
                    class="user-image"
                    :src="userImage"
                    alt="User Image"
					ref="userImage"
                >
            </section>

            <section class="user-details">
                <h4 class="user-name">
                    {{ reportData.name | capitalize }}
                </h4>

                <span class="detail-container">
                    <span class="detail-label">
						Age:
                    </span>

                    {{ reportData.age }}
                </span>

				<span class="detail-container">
                    <span class="detail-label">
						Gender:
                    </span>

                    {{ reportData.gender }}
                </span>

                <span class="detail-container" v-if="reportData.date_joined">
                    <span class="detail-label">
						Date Joined:
                    </span>

					{{ reportData.date_joined }}
                </span>
            </section>
        </section>

        <section class="report-average">
            <section class="average-item">
                <div class="item-detail">
                    <h4 class="item-title">
						Average Heart Rate
                    </h4>

                    <span class="item-value">
                        {{ `${reportData.average_heart_rate | null} BPM` }}
                    </span>
                </div>

                <img
                    :src="averageHeartRateImg()"
                    alt="Average Icon"
                    class="item-img heart"
                >
            </section>

            <section class="average-item">
                <div class="item-detail">
                    <h4 class="item-title">
						Average Emotion
                    </h4>

                    <span class="item-value">
                        {{ reportData.average_emotion_value | capitalize | null }}
                    </span>
                </div>

                <img
                    :src="averageEmotionIcon"
                    alt="Average Icon"
                    class="item-img emotion"
                >
            </section>

            <section class="average-item">
                <div class="item-detail">
                    <h4 class="item-title">
						Average Stress Level
                    </h4>

                    <span class="item-value">
                        {{ reportData.average_stress_level | capitalize | null}}
                    </span>
                </div>

                <img
                    :src="averageStressCaloriesLevel()"
                    alt="Average Icon"
                    class="item-img stress"
                >
            </section>
        </section>
    </div>
</template>

<script>
export default {
	props: {
		reportData: {
			required: true
		}
	},

	data () {
		return {
			userImageRendered: false,
			averageEmotionImgRendered: false
		}
	},

	asyncComputed: {
		userImage: {
			async get () {
				if (this.reportData.image) {
					this.userImageRendered = false

					return new Promise(async (resolve, reject) => {
						const response = await fetch(this.reportData.image)

						const reader = new FileReader()

						reader.onloadend = () => {
							resolve(reader.result)

							this.userImageRendered = true
							this.emitRender('userimage')
						}

						reader.readAsDataURL(await response.blob())
					})
				}

				this.userImageRendered = true
				this.emitRender('userimage')
				return require('@/assets/img/default-avatar.png')
			},

			default: require('@/assets/img/default-avatar.png')
		},

		averageEmotionIcon: {
			async get () {
				const {
					average_emotion_value_path
				} = this.reportData

				this.averageEmotionImgRendered = true

				if (!average_emotion_value_path) {
					this.emitRender('averageimage')

					return require('@/assets/img/default-emoji.png')
				}

				this.averageEmotionImgRendered = false

				return new Promise(async (resolve, reject) => {
					const response = await fetch(process.env.VUE_APP_BASE + average_emotion_value_path)

					const reader = new FileReader()

					reader.onloadend = () => {
						this.averageEmotionImgRendered = true
						resolve(reader.result)

						this.emitRender('averageimage')
					}

					reader.readAsDataURL(await response.blob())
				})
			},

			default: require('@/assets/img/default-emoji.png')
		}
	},

	methods: {
		averageHeartRateImg () {
			return this.reportData.average_stress_level
				? require(`@/assets/img/card icons/heart_${this.reportData.average_stress_level.toLowerCase()}.png`)
				: require('@/assets/img/card icons/heart_low.png')
		},

		averageStressCaloriesLevel () {
			return this.reportData.average_stress_level
				? require(`@/assets/img/card icons/stress_${this.reportData.average_stress_level.toLowerCase()}.png`)
				: require('@/assets/img/card icons/stress_low.png')
		},

		emitRender (itemRendered) {
			if (
				this.userImageRendered &&
                this.averageEmotionImgRendered
			) {
				this.$emit('onUserInfoRender')
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.report-info-container {
    padding-bottom: 20px;

    .report-info {
        display: flex;
        margin-bottom: 10px;

        .image-container {
            width: 75px;
            height: 75px;
            border-radius: 50%;
            overflow: hidden;
            position: relative;
            margin-right: 25px;
			border: 1px solid #dadada;

            .user-image {
                height: 100%;
                min-width: 100%;
                position: absolute;
                margin-left: 50%;
                transform: translateX(-50%);
            }
        }

        .user-details {
            display: flex;
            flex-direction: column;
            justify-content: center;
			flex-shrink: 0;

            .user-name {
                flex-shrink: 0;
                font-size: 1.2em;
            }

            .detail-container {
				font-size: 1em;
				flex-shrink: 0;

                .detail-label {
                    font-weight: 600;
                    margin-right: 5px;
					font-size: 1em;
                }
            }
        }
    }

    .report-average {
        display: flex;
        justify-content: space-between;

		&.japanese {
			.item-title {
				font-size: 10px !important;
			}
		}

        .average-item {
            width: 32%;
            padding: 10px 15px;
            display: flex;
            border: 1px solid #bbbbbb;
            justify-content: space-between;
			align-items: center;
			flex-shrink: 0;

            .item-detail {
				font-size: 1em;
				flex-shrink: 0;
				max-width: 75%;

                .item-title {
                    font-weight: 600;
                    font-size: 1em;
                    margin-bottom: .5em;
                }
            }

            .item-img {
                width: 50px;
				flex-shrink: 0;

				&.emotion {
					width: 43px;
					height: 43px;
				}

				&.stress {
					width: 50px;
					height: 30px;
				}

				&.calories {
					width: 43px;
					height: 46px;
				}
            }
        }
    }
}
</style>
